import { RootState } from '@client/redux/types';
import { HeaderFlashMessage } from '@shared/types/flashMessage';

export const getFlashMessage = (state: RootState) => state.flashMessage;
export const getFlashMessages = (state: RootState) => state.flashMessage.flashMessages;
export const getDisplayHeaderFlashMessage = (state: RootState) =>
    state.flashMessage.displayHeaderFlashMessage;
const emptyHeaderFlashMessage: HeaderFlashMessage = {
    type: null,
    message: null,
};
export const getHeaderFlashMessage = (state: RootState) =>
    state.flashMessage.headerFlashMessage || emptyHeaderFlashMessage;
export const getErrors = (state: RootState) => state.flashMessage.errors;
export const getHeaderNotificationBanner = (state: RootState) =>
    state.flashMessage.headerNotificationBanner || null;
export const getShowNotification = (state: RootState) => state.flashMessage.showNotification;
